export default class FactCtrl {
  constructor($window, Fact, currentFact, FactListFactory, FactList,
    $routeParams, isFactWindow, $scope, CurrentCase, $location, Browser,
    $compile
  ) {
    this.scope = $scope
    this.currentCase = CurrentCase

    this.setFact(currentFact)
    this.model = Fact;

    this.window = $window
    this.location = $location
    this.browser = Browser
    this.isFactWindow = isFactWindow
    $window.isFactWindow = this.isFactWindow

    this.refreshParent = this.refreshParent.bind(this)

    this.factList = this.isFactWindow ? new FactListFactory() : FactList;
    this.factList.subscribe(() => {

      this.facts = this.factList.data.rows ?
        this.factList.data.rows.filter(
          row => row.row !== null
        ).map(row => row.row) : []

    })

    this.factParity = {
      sources: (o1, o2) => {
        return o1 && o2 && o1.every((s, i) => o2[i] && s.id === o2[i].id)
      },
      factDateish: (o1, o2) => {
        return o1 && o2 && ['year', 'month', 'date', 'hour', 'minute',
          'second'
        ].every(d => {
          o2[d] = o2[d] || null // undefined => null for comparison
          o1[d] = o1[d] || null
          return o2[d] === o1[d]
        })
      }
    }

    if ($routeParams.caseId && this.isFactWindow) {
      this.getFacts()
    }
    if ($location.search()['action-guide']) {
      $location.search('action-guide', null);
      var guide = $compile('<lf-action-guide context="fact" />')($scope);

      let body = document.querySelector('body')
      body.insertBefore(guide[0], body.firstChild)

    }
  }
  refreshParent() {
    if (this.window.opener && this.window.opener.angular) {
      let openerCase = this.window.opener.angular.element(
        this.window.opener.document.querySelector('[ng-app]')
      ).injector().get('CurrentCase')
      if (openerCase) {
        openerCase.api.get()
      }
    }
  }
  toggleCases() {
    this.scope.$broadcast('displayCases')
  }
  addFact(data) {
    let p = new this.model(data).api[data.id ? 'update' : 'create']()
    p.then(() => {
      this.refreshParent()
      this.factList.setFact(data)
      this.fact = {}
    })
    return p
  }
  editFact(data) {
    return new this.model(data).api.update()
  }
  getFacts() {
    this.factList.api.getFactsByCreationDate().then(() => {
      this.facts = this.factList.data.rows.filter(
        row => row.row !== null
      ).map(row => row.row);
    })
  }
  showFact(next, newFact) {
    // higher index is older
    if (this.abandonChanges(newFact)) {
      this.index = this.fact.id ?
        this.facts.indexOf(this.fact) + (next ? -1 : 1) :
        next ? -1 : 0;

      if (this.index >= this.facts.length && !this.factList.data.lastResult) {
        this.factList.loadMoreByCreationDate().then(() => {
          this.setFact(this.facts[this.index]);
        });
      } else {
        this.setFact(this.facts[this.index]);
      }

    }
  }
  setFact(fact) {
    this.fact = fact || {}
  }

  openCase() {
    var id = this.currentCase.id || ''

    // from launcher, let launcher open link in default browser
    if (typeof launcher !== 'undefined') {
      launcher.openLink(this.location.protocol() + '://' + this.location.host() +
        (this.location.port() ? ':' + this.location.port() : '') + '/#' +
        '/home/' +
        id);
      return;
    }

    var opener = this.window.opener;
    if (this.browser.name === 'Internet Explorer') {
      // does not refocus buried tab
      this.window.open('#/home/' + id, '_blank').focus();
    } else if (opener && this.browser.name === 'Firefox') {
      // does not refocus buried tab
      this.window.open('#/home/' + id, '_blank').focus();
    } else {
      this.window.open('#/home/' + id, 'FactBox').focus();
    }
  }
  abandonChanges(newFact) {
    var parity = ['content', 'legalIssues', 'sources',
      'tags', 'title', 'factDateish'
    ].every(key => {
      return newFact[key] ? this.factParity[key] ?
        this.factParity[key](this.fact[key], newFact[key]) :
        angular.equals(this.fact[key], newFact[key]) : true
    });
    return parity ||
      this.window.confirm("You have unsaved changes. Abandon changes?");
  }
}
FactCtrl.$inject = ['$window', 'Fact', 'currentFact', 'FactListFactory',
  'FactList', '$routeParams', 'isFactWindow', '$scope', 'CurrentCase',
  '$location', 'Browser', '$compile'
];



// WEBPACK FOOTER //
// ./project/pages/fact/fact.controller.js